import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

const Wedding: React.FC = () => {
  React.useEffect(() => {
    const paymentLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK;
    if (paymentLink) {
      window.location.href = paymentLink;
    } else {
      console.error('Payment link not configured');
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      fontFamily: 'sans-serif'
    }}>
      <p>Redirecting to wedding registry...</p>
    </div>
  );
};

const Home: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    flexDirection: 'column',
    fontFamily: 'sans-serif'
  }}>
    <h1>Welcome</h1>
    <p>Visit <Link to="/wedding" style={{ color: '#0066cc' }}>/wedding</Link> for the registry</p>
  </div>
);

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/wedding" element={<Wedding />} />
      <Route path="*" element={<Home />} />
    </Routes>
  </BrowserRouter>
);

export default App;
